const defaultProcessor = require('./default');

module.exports = function (eventName, eventData) {
  const processChange = !eventData.source ||
    !eventData.source.url ||
    eventData.source.smart_load !== false;

  if (!processChange) {
    const deferred = $.Deferred();
    deferred.reject(new Error('Image update failed'));
    return deferred.promise();
  }

  return defaultProcessor.apply(this, arguments);
};
